import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rateSectionAriaLabel: {
    defaultMessage: 'Rate section',
    description: 'Aria label for the rate section',
    id: 'cSKDyn',
  },
});
